<div class="cannabis-invitation-banner" *ngIf="visible">
  <div class="banner-content">
    <button mat-icon-button class="banner-close" type="button" (click)="close()" aria-label="Cerrar banner">
      <mat-icon>close</mat-icon>
    </button>

    <div class="banner-body">
      <div class="banner-text">
        <strong class="banner-title">{{ invitationService.config.title }}</strong>
        <p class="banner-subtitle">{{ invitationService.config.shortMessage }}</p>
      </div>

      <div class="banner-links" aria-label="Enlaces del evento">
        <a
          class="banner-link banner-link-eventbrite"
          [href]="invitationService.config.eventbrite.url"
          target="_blank"
          rel="noopener noreferrer">
          <mat-icon>open_in_new</mat-icon>
          <span class="banner-link-text">{{ invitationService.config.eventbrite.label }}</span>
        </a>
        <a
          *ngFor="let pdf of invitationService.getInvitationPdfItems()"
          class="banner-link"
          [href]="pdf.url"
          rel="noopener noreferrer"
          (click)="invitationService.openPdfPreviewAndDownload($event, pdf.url, pdf.downloadFileName)">
          <mat-icon>picture_as_pdf</mat-icon>
          <span class="banner-link-text">{{ pdf.bannerLabel }}</span>
        </a>
      </div>
    </div>
  </div>
</div>
